import { carbonIntensityDataReducer } from 'src/modules/carbon-intensity/reducers/carbonIntensityDataReducer';
import { CarbonIntensityState } from 'src/modules/carbon-intensity/types/CarbonIntensityState';
import { chainReducers } from 'src/utils/chainReducers';

const defaultState: CarbonIntensityState = new Map();

export const carbonIntensityReducer = chainReducers(defaultState, [
  carbonIntensityDataReducer,
]);
